import React, { useEffect, useState } from "react";
import {
  X,
  MapPin,
  Clock,
  Phone,
  Mail,
  User,
  Store,
  Tag,
  Share2
} from "lucide-react";



export default function Sidebar({
  isOpen,
  onClose
}) {
  const [restaurant, setRestaurant] =
    useState(null);


  /* ===============================
     LOAD FROM SESSION
  ============================== */

useEffect(() => {
  if (isOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [isOpen]);

  useEffect(() => {
    const storedData =
      sessionStorage.getItem(
        "restaurantData"
      );

    if (storedData) {
      setRestaurant(
        JSON.parse(storedData)
      );
    }
  }, [isOpen]);

  /* ===============================
     SHARE MENU URL
  ============================== */

  const handleShare = async () => {
    if (!restaurant?.menuUrl)
      return;

    try {
      if (navigator.share) {
        await navigator.share({
          title:
            restaurant.restaurantName,
          text:
            "Check out our menu",
          url: restaurant.menuUrl
        });
      } else {
        await navigator.clipboard.writeText(
          restaurant.menuUrl
        );
        alert(
          "Menu link copied to clipboard"
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          style={styles.overlay}
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          ...styles.sidebar,
          left: isOpen ? "0" : "-360px"
        }}
      >
        {/* Header */}
        <div style={styles.header}>
          <h3>Restaurant Details</h3>

          <X
            size={24}
            color={styles.icon.color}
            style={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </div>

        <div style={styles.content}>

          {/* Logo */}
          {restaurant?.logoUrl && (
            <div style={styles.logoBox}>
              <img
                src={`${restaurant.logoUrl}`}
                alt="logo"
                style={styles.logo}
              />
            </div>
          )}

          <Row
            icon={<Store size={18} />}
            text={
              restaurant?.restaurantName
            }
          />

          <Divider />

          <Row
            icon={<Tag size={18} />}
            text={
              restaurant?.category
            }
          />

          <Divider />

          <Row
            icon={<MapPin size={18} />}
            text={
              restaurant?.restaurantAddress
            }
          />

          <Divider />

          <Row
            icon={<Clock size={18} />}
            text={
              restaurant?.openingTime +
              " - " +
              restaurant?.closingTime
            }
          />

          <Divider />

          <Row
            icon={<Phone size={18} />}
            text={
              restaurant?.phone
            }
          />

          <Divider />

          <Row
            icon={<Mail size={18} />}
            text={
              restaurant?.email
            }
          />

          <Divider />

          <Row
            icon={<User size={18} />}
            text={
              restaurant?.ownerName
            }
          />

          {/* QR Code */}
          {restaurant?.qrUrl && (
            <>
              <Divider />

              <div style={styles.qrBox}>
              

                <img
                  src={restaurant.qrUrl}
                  alt="QR Code"
                  style={styles.qr}
                />
              </div>
            </>
          )}

          {/* SHARE BUTTON */}

          {restaurant?.menuUrl && (
            <>
              <Divider />

              <button
                onClick={handleShare}
                style={styles.shareButton}
              >
                <Share2 size={18} />
                Share Menu
              </button>
            </>
          )}

        </div>
      </div>
    </>
  );
}

/* Row */

function Row({ icon, text }) {
  return (
    <div style={styles.row}>
      {React.cloneElement(icon, {
        color: styles.icon.color
      })}
      <span>{text}</span>
    </div>
  );
}

/* Divider */

function Divider() {
  return (
    <div style={styles.divider} />
  );
}

/* Styles */

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    background:
      "rgba(0,0,0,0.35)",
    zIndex: 999
  },

sidebar: {
  position: "fixed",
  top: 0,
  // left: isSidebarOpen ? "0" : "-360px",
  width: "360px",
  height: "100%",
  background: "#ffffff",
  boxShadow: "2px 0 12px rgba(0,0,0,0.15)",
  transition: "left 0.3s ease",
  zIndex: 1000,
  padding: "20px",
  overflowY: "auto"
},

  header: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems: "center",
    marginBottom: "20px"
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: "14px"
  },

  logoBox: {
    display: "flex",
    justifyContent: "center"
  },

  logo: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    borderRadius: "12px",
    border:"none"
  },

  row: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "15px"
  },

  divider: {
    height: "1px",
    background: "#eee",
    margin: "6px 0"
  },

  qrBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px"
  },

  qr: {
    width: "140px",
    height: "140px",
    objectFit: "contain",
    border: "1px solid #ddd",
    padding: "6px",
    borderRadius: "8px"
  },

  shareButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "12px",
    background: "#ff6b00",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer"
  },

  icon: {
    color: "#ff6b00"
  }
};